import { createDisplayName } from '../../../OmazeUI.config';

export const gridCellDisplayName: string = createDisplayName('GridCell');
